import { ContactForm } from "../components/ContactForm";
import { consultationSteps, Steps } from "../components/Steps";

export function ConsultationPage() {
  return (
    <>
      <header className="page-head page-head--deep">
        <div className="wrap page-head__grid">
          <div>
            <p className="index-label">
              <span className="index-label__number">15 min</span>
              <span>Video consultation</span>
            </p>
            <h1 className="display">Show us the problem. <em>Get a practical next step.</em></h1>
          </div>
          <p className="page-head__lede">Tell us what you are seeing, what changed, and any water readings you have. We will review the request and follow up about scheduling.</p>
        </div>
      </header>
      <section className="wrap consult-steps" aria-label="Consultation process">
        <Steps steps={consultationSteps} />
      </section>
      <section className="form-layout wrap">
        <div className="form-layout__intro">
          <p className="index-label"><span className="index-label__number">Before you send</span></p>
          <h2 className="display">The more specific the picture, the more useful the call.</h2>
          <ul className="check-list">
            <li>Current ammonia, nitrite, and nitrate readings</li>
            <li>Tank size, inhabitants, and filter type</li>
            <li>When the tank was last serviced</li>
            <li>Recent food, livestock, treatment, or equipment changes</li>
          </ul>
          <p className="safety-note"><strong>Animal emergency?</strong> Aquarium Helpline is educational support, not veterinary care. Contact an aquatic veterinarian for urgent health concerns.</p>
        </div>
        <ContactForm variant="consultation" />
      </section>
    </>
  );
}
